import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography, Paper } from "@mui/material";

function Validations({ item }) {
  const { t } = useTranslation();

  const errors = item?.validation_errors?.[0]?.errors || [];
  const errorDate = item?.validation_errors?.[0]?.error_date;

  if (item?.IsValid || errors.length === 0) return null;

  return (
    <Paper
      elevation={0}
      className="!mt-2 border !rounded-lg overflow-hidden"
      sx={{ border: "1px solid #e2e8f0" }}
    >
      {/* Header */}
      <Box
        sx={{
          backgroundColor: "#d1d5db",
          px: 2,
          py: 0.75,
          borderBottom: "2px solid #d1d5db",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography
          sx={{
            fontSize: "0.7rem",
            fontWeight: 700,
            color: "#1e293b",
            textTransform: "uppercase",
            letterSpacing: "0.025em",
          }}
        >
          {t("Validation Errors")}
        </Typography>
        {errorDate && (
          <span className="text-[10px] font-semibold text-gray-600">
            {t("Date")}: {errorDate}
          </span>
        )}
      </Box>

      {/* Error Rows */}
      <Box className="bg-white divide-y divide-gray-100">
        {errors.map((el, index) => (
          <div
            key={index}
            className="grid grid-cols-1 md:grid-cols-3 gap-x-4 gap-y-1 px-3 py-2"
          >
            <div className="flex flex-col">
              <span className="text-[10px] font-bold text-gray-500 uppercase tracking-wider">
                {t("Error Code")}
              </span>
              <span className="text-[11px] font-semibold text-red-600">
                {el?.error_code || "___"}
              </span>
            </div>
            <div className="flex flex-col">
              <span className="text-[10px] font-bold text-gray-500 uppercase tracking-wider">
                {t("Error Message")}
              </span>
              <span className="text-[11px] font-semibold text-[#0070C2]">
                {el?.error_message || "___"}
              </span>
            </div>
            <div className="flex flex-col">
              <span className="text-[10px] font-bold text-gray-500 uppercase tracking-wider">
                {t("Value")}
              </span>
              <span className="text-[11px] font-semibold text-[#0070C2]">
                {el?.value_string || "___"}
              </span>
            </div>
          </div>
        ))}
      </Box>
    </Paper>
  );
}

export default Validations;
